import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Nav from "./components/Nav";
import Footer from "./components/Footer";

import Landing from "./pages/Landing";
import Diagnose from "./pages/Diagnose";
import Snapshot from "./pages/Snapshot";
import EmbroideryCost from "./pages/EmbroideryCost";
import Join from "./pages/Join";
import Welcome from "./pages/Welcome";
import Canceled from "./pages/Canceled";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Nav />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/diagnose" element={<Diagnose />} />
          <Route path="/snapshot" element={<Snapshot />} />
          <Route path="/embroidery-cost" element={<EmbroideryCost />} />
          <Route path="/join" element={<Join />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/canceled" element={<Canceled />} />
        </Routes>
        <Footer />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "var(--warm-white)",
              color: "var(--ink)",
              border: "1px solid var(--border)",
              borderRadius: 16,
              fontFamily: "Jost, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
